<template>
  <div class="row">
    <div v-if="deliveryNote" class="col-sm-6 col-xs-12">
      <div v-if="deliveryNote.distributorFrom">
        <label class="control-label font-weight-bold mr-2">DISTRIBUIDOR DE SALIDA: </label>
        <span>{{ deliveryNote.distributorFrom.name }}</span>
      </div>
      <div v-else>
        <label class="control-label font-weight-bold mr-2">SALIDA DESDE: </label>
        <span> {{ MAIN_DEPOSIT_LABEL }}</span>
      </div>
      <div v-if="deliveryNote.distributorTo">
        <label class="control-label font-weight-bold mr-2">DISTRIBUIDOR DE ENTRADA: </label>
        <span>{{ deliveryNote.distributorTo.name }}</span>
      </div>
      <div v-else>
        <label class="control-label font-weight-bold mr-2">ENTRADA HACIA: </label>
        <span> {{ MAIN_DEPOSIT_LABEL }} </span>
      </div>

      <div v-if="deliveryNote.producer">
        <label class="control-label font-weight-bold mr-2">PRODUCTOR: </label>
        <span>{{ deliveryNote.producer.businessName }}</span>
      </div>
    </div>

    <div class="col-sm-5 offset-sm-1 col-xs-12">
      <div v-if="deliveryNote.campaign">
        <label class="control-label font-weight-bold mr-2">CAMPAÑA: </label>
        <span>{{ deliveryNote.campaign.name }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA: </label>
        <span>{{ deliveryNote.date | date }}</span>
      </div>
      <div v-if="deliveryNote.code">
        <label class="control-label font-weight-bold mr-2">NUMERO REMITO: </label>
        <span>{{ deliveryNote.code }}</span>
      </div>
    </div>

    <div v-if="deliveryNote.comment" class="col-12">
      <label class="control-label font-weight-bold mr-2">RAZÓN DE AJUSTE: </label>
      <!-- TODO check de donde viene y si viene ? -->
      <span>{{ deliveryNote.comment }}</span>
    </div>
  </div>
</template>

<script>
import { MAIN_DEPOSIT_LABEL } from '@/util/constants/deliveryNotes';

export default {
  props: {
    deliveryNote: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      MAIN_DEPOSIT_LABEL,
    };
  },
};
</script>
